<template>
  <div :class="['page-content']">
    <h2 :class="title">Welcome to icons.io</h2>
    <p>{{ $store.state.meta.description }}. <intro-text /></p>
    <v-container fluid grid-list-sm>
      <v-layout row wrap>
        <v-flex xs12 sm6 lg4 v-for="(icons, service) in icons" :key="service" :class="['services-list']">
          <v-card :class="['elevation-8', 'ma-2', 'icon-preview']" router :to="service">
            <v-card-title primary-title :class="['pb-0', 'mb-0']">
              <h3 :class="headline" v-html="service" />
            </v-card-title>
            <v-card-text :class="['pt-0', 'mt-0', service]">
              <ul :class="['icons-list', 'inline-list', 'no-bullet-list', 'mt-3']">
                <li v-for="icon in preview(service)" :key="icon" :class="['pa-1']">
                  <v-icon v-html="icon" />
                </li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-btn block dark :color="primaryColor">View All {{ getLength(service) }} Icons <v-icon>chevron_right</v-icon></v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 lg4>
          <vue-adsense ad-severity="block" :ad-client="adClient" ad-slot="8182071534" ad-format="fluid" ad-layout="in-article" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import IntroText from '../components/intro-text'

export default {
  name: 'IndexPage',
  components: {
    IntroText
  },
  data () {
    return {
      icons: this.$store.getters.icons,
      headline: this.$store.state.headline || [],
      title: this.$store.state.title || [],
      primaryColor: this.$store.state.primaryColor || '',
      adClient: this.$store.state.googleAdSenseAdClient
    }
  },
  methods: {
    getLength (service) {
      return this.icons[service].length
    },
    preview (service) {
      return this.icons[service].slice(0, service !== 'emoji-css' ? this.$store.state.iconsPreviewLength : 12)
    }
  }
}
</script>
<style>
.services-list .headline
{
  text-align: center;
  display: block;
  width: 100%;
  font-size: 18px !important;
}

.services-list .emoji-css ul
{
  overflow: hidden;
  height: 160px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue